import React, { createContext, useContext, useState, useEffect } from 'react';

const QuoteContext = createContext();
const STORAGE_KEY = 'solarquotepro_quote';

// ✅ Fix #5 : valeurs par défaut centralisées — source unique de vérité
const defaultQuoteData = {
  clientInfo: { name: '', address: '', phone: '', email: '' },
  companyInfo: {
    name: 'TAKOUSSANE ENERGY',
    address: 'BP 302 Rufisque Ouest, Dakar',
    phone: '(+221) 33 836 67 83',
    mob: '(+221) 78 346 88 51',
    email: 'contact@takoussane.com',
    logo: '',
  },
  items: [],
  subtotal: 0,
  deliveryCost: 0,
  vatRate: 18,
  vat: 0,
  discount: 0,
  totalAmount: 0,
  totalWithVat: 0,
  deliveryOption: '1500_50',
  distance: 0,
  vatOption: 'without_vat',
  termsConditions: `1. Validité de l'offre : 30 jours à compter de la date d'émission.\n2. Paiement : 30% à la commande, solde à la livraison.\n3. Livraison : selon les conditions convenues.\n4. Garantie : voir conditions spécifiques par produit.`,
  legalInfo: `TAKOUSSANE ENERGY - Entreprise spécialisée en solutions solaires photovoltaïques au Sénégal.\nRC : SN DKR 2016 A 4486 - NINEA : 005826948\nSiège social : BP 302 Rufisque Ouest, Dakar - SÉNÉGAL`,
  offerValidity: '30',
  warranties: {
    system: '2',
    panels: '12',
    performance: '86.4',
    degradation: '0.40',
  },
  certifications: ['CE', 'TÜV', 'RoHS', 'IP68', 'IP65'],
  quoteNumber: `DEV-${new Date().getFullYear()}-${String(Math.floor(Math.random() * 9000) + 1000)}`,
  date: new Date().toLocaleDateString('fr-FR'),
  status: 'draft',
  conditionsValidite: '',
  conditionsPaiement: '',
  conditionsGaranties: '',
};

// ✅ Fix #5 : charger depuis localStorage au démarrage (survie au rechargement)
const loadFromStorage = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      // Fusionner avec les défauts pour garantir tous les champs présents
      return { ...defaultQuoteData, ...parsed };
    }
  } catch (e) {
    console.warn('Erreur lecture localStorage:', e);
  }
  return defaultQuoteData;
};

export const useQuote = () => {
  return useContext(QuoteContext);
};

export const QuoteProvider = ({ children }) => {
  // ✅ Fix #5 : initialiser depuis localStorage si disponible
  const [quoteData, setQuoteData] = useState(loadFromStorage);

  // ✅ Fix #5 : persister automatiquement à chaque modification du contexte
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(quoteData));
    } catch (e) {
      console.warn('Erreur écriture localStorage:', e);
    }
  }, [quoteData]);

  const loadQuoteData = (newData) => {
    setQuoteData(prevData => ({ ...defaultQuoteData, ...newData }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...defaultQuoteData, ...newData }));
  };

  const updateQuoteData = (newData) => {
    setQuoteData(prevData => ({
      ...prevData,
      ...newData,
    }));
  };

  const updateQuoteStatus = (newStatus) => {
    setQuoteData(prevData => ({
      ...prevData,
      status: newStatus,
    }));
  };

  // ✅ Nouveau : réinitialiser pour un nouveau devis propre
  const resetQuoteData = () => {
    const freshQuote = {
      ...defaultQuoteData,
      quoteNumber: `DEV-${new Date().getFullYear()}-${String(Math.floor(Math.random() * 9000) + 1000)}`,
      date: new Date().toLocaleDateString('fr-FR'),
      status: 'draft',
    };
    setQuoteData(freshQuote);
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <QuoteContext.Provider value={{ quoteData, updateQuoteData, updateQuoteStatus, resetQuoteData, loadQuoteData }}>
      {children}
    </QuoteContext.Provider>
  );
};